import { editStoreBuilder } from '@/main/store/pages/edit/builder';
import { EditStoreProps } from '@/main/store/@types/edit.d';

import { NAME, CRUMB_LABEL_KEY, VERIFICATION_HISTORY_PARTS, DEPENDENT_TABLES as depTableNames } from '../constants';
import { apiProvider } from '../api';

const edit = {
	Id: null as number | null,
	TicketId: null as number | null,
};

export const store = editStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {},
	depTableNames,
	depTableSettings: {
		[VERIFICATION_HISTORY_PARTS]: {
			loadByEntityId: true,
			filter(state) {
				return {
					Id: state.edit.Id,
				};
			},
		},
	},
	edit,
	localState: {},
	extraActions: {},
	extraMutations: {},
	extraGetters: {},
	props: {
		filter: {
			TicketId: null as number | null,
		},
		mode: null,
	} as EditStoreProps,
});
